/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RuntimeError/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RuntimeError({
  children,
  viewPath = "/App/RuntimeError"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="RuntimeError.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="RuntimeError.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-2rUDGi': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="🤯"
 fontSize={50}
/>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 color="#e15829"
 fontSize={22}
 text="Something went wrong"
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={30}
 text="We apologize for the inconvenience."
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={10}
 text="Report this problem to your clinic to help us solve it faster."
 textAlign="center"
/>
</div>
</div>
{children}
</React.Fragment>)
}